import { render, staticRenderFns } from "./ocrUpdOther.vue?vue&type=template&id=e365ad5c"
import script from "./ocrUpdOther.vue?vue&type=script&lang=js"
export * from "./ocrUpdOther.vue?vue&type=script&lang=js"
import style0 from "./ocrUpdOther.vue?vue&type=style&index=0&id=e365ad5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports